import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import './Person.scss';

var Person = /*#__PURE__*/function (_Component) {
  _inherits(Person, _Component);

  var _super = _createSuper(Person);

  function Person() {
    var _this;

    _classCallCheck(this, Person);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getName", function () {
      var name = '';

      if (_this.props.person != null && _this.props.person.firstName != null) {
        name = _this.props.person.firstName;
      }

      if (_this.props.person != null && _this.props.person.lastName != null) {
        name = name.length > 0 ? name + ' ' + _this.props.person.lastName : _this.props.person.lastName;
      }

      return name;
    });

    _defineProperty(_assertThisInitialized(_this), "getInitials", function () {
      var name = _this.getName();

      if (name != null && name.length > 0) {
        var nameSplit = name.split(' ');
        if (nameSplit.length > 1) return nameSplit[0].charAt(0).toUpperCase() + nameSplit[nameSplit.length - 1].charAt(0).toUpperCase();
        if (nameSplit.length == 1) return nameSplit[0].charAt(0).toUpperCase();
      } else {
        return '';
      }
    });

    return _this;
  }

  _createClass(Person, [{
    key: "render",
    value:
    /* Events */
    // Empty

    /* Render methods */
    function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "person-container",
        style: _objectSpread({
          display: 'inline-block'
        }, this.props.style)
      }, /*#__PURE__*/React.createElement("div", {
        className: "person size--" + this.props.size
      }, /*#__PURE__*/React.createElement("div", {
        className: "avatar"
      }, this.getInitials()), /*#__PURE__*/React.createElement("div", {
        className: "name"
      }, this.getName())), this.props.children ? /*#__PURE__*/React.createElement("div", {
        className: "person-children size--" + this.props.size
      }, this.props.children) : null);
    }
  }]);

  return Person;
}(Component);

_defineProperty(Person, "defaultProps", {
  person: {
    firstName: '',
    lastName: '',
    email: '',
    id: ''
  },
  showName: true,
  showAvatar: true,
  size: 'sm'
});

export default Person;